import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaHome, FaCheckCircle, FaMedal } from 'react-icons/fa';
import { auth } from './firebase';
import './buypacks.css';

import tokenImage1 from './images/tokenpic1.png.png';
import tokenImage2 from './images/tokenpic2.png.png';
import tokenImage3 from './images/tokenpic3.png.png';
import tokenImage4 from './images/tokenpic4.png.png';



function BuyPacks() {
  const [selectedPack, setSelectedPack] = useState('');
  const [selectedToken, setSelectedToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
const [earnedTokens, setEarnedTokens] = useState(0);
const [purchasedPack, setPurchasedPack] = useState('');


  const API_BASE =
    window.location.hostname === 'localhost'
      ? 'http://localhost:5000'
      : 'https://razorpayapi-hhkhmg7zla-uc.a.run.app';

  const tokenBundles = [
    { name: 'Starter Tokens', price: 5, tokens: 1, image: tokenImage1 },
    { name: 'Regular Tokens', price: 20, tokens: 5, image: tokenImage2 },
    { name: 'Popular Tokens', price: 45, tokens: 12, image: tokenImage3 },
    { name: 'Mega Tokens', price: 90, tokens: 25, image: tokenImage4 },
  ];

  const packDetails = {
    basic: { maxListings: 2, validityDays: 15, price: 49 },
    verified: { maxListings: 5, validityDays: 30, price: 199 },
    featured: { maxListings: 10, validityDays: 60, price: 299 },
  };

  const calculateTotals = () => {
    let totalRupees = 0;
    let tokenCount = 0;

    if (selectedPack) totalRupees += packDetails[selectedPack].price;
    if (selectedToken) {
      const bundle = tokenBundles.find(b => b.name === selectedToken);
      totalRupees += bundle.price;
      tokenCount = bundle.tokens;
    }

    return { totalRupees, tokenCount };
  };

  const handlePurchase = async () => {
    if (loading) return;

    if (!selectedPack && !selectedToken) {
      alert('Please select a pack or token bundle.');
      return;
    }

    if (!auth.currentUser) {
      alert('Please login to continue.');
      return;
    }

    setLoading(true);

    try {
      const { totalRupees, tokenCount } = calculateTotals();
      const amountInPaise = totalRupees * 100;

      const token = await auth.currentUser.getIdToken();

      const orderResponse = await fetch(`${API_BASE}/createOrder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          amount: amountInPaise,
          pack: selectedPack || null,
          tokens: tokenCount || 0,
        }),
      });

      if (!orderResponse.ok) throw new Error('Order creation failed');

      const order = await orderResponse.json();
      if (!order.id) throw new Error('Invalid Razorpay order response');

      const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY_ID || '';
      if (!razorpayKey) throw new Error('Razorpay key not configured');

      // Load Razorpay SDK if not already loaded
      if (typeof window.Razorpay === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://checkout.razorpay.com/v1/checkout.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Failed to load Razorpay SDK'));
          document.body.appendChild(script);
        });
      }

      const options = {
        key: razorpayKey,
        amount: order.amount,
        currency: 'INR',
        name: 'ApkaGhr',
        description: `Purchase Pack/Tokens`,
        order_id: order.id,
  handler: async function (response) {
    try {
      const verifyRes = await fetch(`${API_BASE}/verifyPaymentAndGrant`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          order_id: response.razorpay_order_id,
          payment_id: response.razorpay_payment_id,
          signature: response.razorpay_signature,
          pack: selectedPack || null,
          tokens: tokenCount || 0,
          amount: amountInPaise,
        }),
      });

      const verifyData = await verifyRes.json();

      if (verifyData.success) {
        setEarnedTokens(tokenCount);
        setPurchasedPack(selectedPack || '');
        setSelectedPack('');
        setSelectedToken('');
        setLoading(false);

        setTimeout(() => {
          setShowSuccessDialog(true);
        }, 100);
      } else {
        setLoading(false);
        alert('Payment verification failed.');
      }
    } catch (err) {
      console.error('Verification error:', err);
      setLoading(false);
      alert('Payment verification failed.');
    }
  },

  prefill: { email: auth.currentUser.email || '' },
  theme: { color: '#3399cc' },

  // Optional: handle cancel/close
  modal: {
    ondismiss: function () {
      setLoading(false);
    },
  },
};
      
      

      new window.Razorpay(options).open();
    } catch (err) {
      console.error('Purchase Error:', err);
      alert('Something went wrong. Check console.');
      setLoading(false);
      
    }
  };


  const { totalRupees } = calculateTotals();

 return (
  <>
    {/* Loading Overlay */}
    {loading && (
      <div className="loading-overlay">
        <div className="spinner"></div>
        <p>Processing your payment...</p>
      </div>
    )}

    {/* Inline Success Dialog */}
    {showSuccessDialog && (
      <div className="success-dialog-overlay">
        <div className="success-dialog">
          <button className="close-icon" onClick={() => setShowSuccessDialog(false)}>
            ✖
          </button>
          <div className="success-icon">🎉</div>
          <h2 className="success-title">Purchase Successful!</h2>
          <p className="success-message">
            You received <strong>{earnedTokens}</strong> tokens
            {purchasedPack ? ` and unlocked the ${purchasedPack} plan 🎁` : ""}.
          </p>
          <button className="ok-btn" onClick={() => setShowSuccessDialog(false)}>OK</button>
        </div>
      </div>
    )}

    <motion.div
      className="pack-wrapper"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="section-heading">PLANS TO LIST HOUSE</h2>

      <div className="pack-container">
        {/* Basic */}
        <div
          className={`pack-card basic ${selectedPack === 'basic' ? 'selected' : ''}`}
          onClick={() => setSelectedPack(selectedPack === 'basic' ? '' : 'basic')}
        >
          <div className="icon-wrapper">
            <FaHome className="home-icon" />
          </div>
          <div className="price">₹49</div>
          <div className="title">Basic Plan</div>
          <ul>
            <li>🏠 List up to 2 houses</li>
            <li>🖼️ Upload up to 4 Photos</li>
            <li>💬 Chat Option Enabled</li>
            <li>📅 Validity - 15 days</li>
          </ul>
        </div>

        {/* Verified */}
        <div
          className={`pack-card verified ${selectedPack === 'verified' ? 'selected' : ''}`}
          onClick={() => setSelectedPack(selectedPack === 'verified' ? '' : 'verified')}
        >
          <div className="icon-wrapper">
            <FaCheckCircle className="verified-icon" />
          </div>
          <div className="price">₹199</div>
          <div className="title">Verified Plan</div>
          <ul>
            <li>🏠 List up to 5 Houses</li>
            <li>🖼️ Upload up to 6 Photos</li>
            <li>💬 Chat Options Enabled</li>
            <li>✅ Verified Tick</li>
            <li>📆 Validity: 30 Days</li>
          </ul>
        </div>

        {/* Featured */}
        <div
          className={`pack-card premium-plus ${selectedPack === 'featured' ? 'selected' : ''}`}
          onClick={() => setSelectedPack(selectedPack === 'featured' ? '' : 'featured')}
        >
          <div className="featured-badge">FEATURED</div>
          <div className="icon-wrapper">
            <FaMedal className="badge-icon-buypacks" />
          </div>
          <div className="price">₹299</div>
          <div className="title">Premium Pack</div>
          <ul>
            <li>🏠 List up to 10 Houses</li>
            <li>🖼️ Upload up to 8 Photos</li>
            <li>💬 Chat Options Enabled</li>
            <li>✅ Verified Tick</li>
            <li>🎥 Upload 1 House Video</li>
            <li>🏅 Premium Badge</li>
            <li>📆 Validity: 60 Days</li>
          </ul>
        </div>
      </div>

      <h2 className="section-heading" style={{ marginTop: 50 }}>BUY TOKENS</h2>
      <div className="token-bundles">
        {tokenBundles.map((bundle, index) => (
          <div
            key={index}
            className={`token-bundle-card ${selectedToken === bundle.name ? 'selected' : ''}`}
            onClick={() => setSelectedToken(selectedToken === bundle.name ? '' : bundle.name)}
          >
            <img src={bundle.image} alt={bundle.name} className="token-image" />
            <div className="token-overlay">
              <h3 className="token-title">{bundle.name}</h3>
              <div className="token-count">{bundle.tokens} Tokens</div>
              <div className="token-price">₹{bundle.price}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="purchase-summary">
        <p>💰 Price: ₹{totalRupees}</p>
        <p>⚡ Platform Fee (2%): ₹{(totalRupees * 0.02).toFixed(2)}</p>
        <hr />
        <p>🏷️ <strong>Subtotal: ₹{(totalRupees + totalRupees * 0.02).toFixed(2)}</strong></p>
      </div>

      <div className="purchase-container">
        <button
          className="purchase-button"
          onClick={handlePurchase}
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Purchase Pack/Tokens'}
        </button>
      </div>
    </motion.div>
  </>
);


}

export default BuyPacks;
